import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    staticClass: "zoom-out_svg__icon",
    attrs: {
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c("path", {
    attrs: {
      "d": "M948.522 896.4 715.467 663.347c58.54-70.264 95.164-159.438 95.164-258.044C810.63 181.458 629.166 0 405.32 0 181.486.001.022 181.458.022 405.301c0 223.838 181.465 405.302 405.3 405.302 98.6 0 187.773-36.617 258.038-95.15l233.056 233.056c14.391 14.384 37.715 14.384 52.106 0s14.393-37.73.001-52.108zm-543.2-159.489c-183.136 0-331.601-148.465-331.601-331.61S222.186 73.69 405.323 73.69c183.144 0 331.61 148.466 331.61 331.61 0 160.64-129.895 331.61-331.61 331.61z"
    }
  }), _c("path", {
    attrs: {
      "d": "M552.706 368.456H257.948c-20.353 0-36.853 16.5-36.853 36.845s16.5 36.845 36.853 36.845h294.758c20.353 0 36.845-16.5 36.845-36.845s-16.492-36.845-36.845-36.845z"
    }
  })]);
};
var ZoomOut = {
  render
};
var index = function index2() {
  return svg({
    name: "IconZoomOut",
    component: ZoomOut
  })();
};
export {
  index as default
};
